function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#4CC2FF;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#A80056;}\r\n\t.st3{fill:#FF0000;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Common_App_Electronic"
}, /*#__PURE__*/React.createElement("g", {
  id: "computer"
}, /*#__PURE__*/React.createElement("rect", {
  x: 27,
  y: 34.3,
  className: "st0",
  width: 36,
  height: 25.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 41.9,
  y: 57.7,
  className: "st0",
  width: 6.2,
  height: 8
}), /*#__PURE__*/React.createElement("rect", {
  x: 31.6,
  y: 64.3,
  className: "st0",
  width: 26.8,
  height: 3.3
}), /*#__PURE__*/React.createElement("rect", {
  x: 30.4,
  y: 37.5,
  className: "st1",
  width: 29.2,
  height: 18.7
})), /*#__PURE__*/React.createElement("g", {
  id: "text"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M35,51.7c-1.7-1.6-2.2-3.6-2.2-5.3c0-1.2,0.4-3.3,2-4.9c1.1-1.1,2.7-1.9,5.5-1.9c0.7,0,1.7,0.1,2.6,0.2 c0.7,0.1,1.2,0.2,1.9,0.3c0.1,0,0.2,0.1,0.2,0.2c0,0.1-0.1,0.4-0.1,1c0,0.6,0,1.6-0.1,1.9s-0.1,0.4-0.2,0.4 c-0.1,0-0.1-0.1-0.1-0.4c0-0.7-0.3-1.4-0.8-1.8c-0.6-0.5-2-1-3.6-1c-2.4,0-3.5,0.7-4.1,1.3c-1.3,1.3-1.6,2.9-1.6,4.7 c0,3.4,2.6,6.6,6.5,6.6c1.4,0,2.4-0.2,3.1-0.9c0.4-0.4,0.6-1.2,0.7-1.5c0-0.2,0.1-0.3,0.2-0.3c0.1,0,0.1,0.1,0.1,0.3 c0,0.1-0.2,1.7-0.4,2.3c-0.1,0.3-0.1,0.4-0.5,0.5c-0.7,0.3-2.1,0.4-3.2,0.4C38.3,53.7,36.5,53,35,51.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M49.7,48.1c-0.1,0-0.1,0.1-0.2,0.1l-1.1,3.2c-0.2,0.5-0.3,0.9-0.3,1.2c0,0.4,0.3,0.5,0.6,0.5 c0.1,0,0.1,0,0.2,0c0.2,0,0.2,0,0.2,0.1c0,0.1-0.2,0.1-0.3,0.1c-0.4,0-1.2-0.1-1.4-0.1s-1.2,0.1-2,0.1c-0.2,0-0.3,0-0.3-0.1 c0-0.1,0.1-0.1,0.3-0.1c0.1,0,0.3,0,0.4,0c0.8-0.1,1.2-0.8,1.5-1.7l4.1-11.2c0.2-0.6,0.3-0.7,0.4-0.7c0.1,0,0.2,0.1,0.4,0.6 c0.3,0.7,3.1,8.1,4.2,10.9c0.6,1.6,1.2,1.9,1.5,2c0.3,0.1,0.6,0.1,0.7,0.1c0.1,0,0.2,0,0.2,0.1c0,0.1-0.2,0.1-0.4,0.1 c-0.3,0-1.6,0-2.8,0c-0.3,0-0.5,0-0.5-0.1c0-0.1,0.1-0.1,0.1-0.1c0.1,0,0.2-0.2,0.1-0.5l-1.7-4.4c0-0.1-0.1-0.1-0.2-0.1H49.7z  M53.4,47.5c0.1,0,0.1-0.1,0.1-0.1l-1.7-4.9c-0.1-0.3-0.2-0.3-0.3,0l-1.6,4.9c0,0.1,0,0.1,0.1,0.1H53.4z"
})), /*#__PURE__*/React.createElement("rect", {
  x: 27,
  y: 45,
  className: "st3",
  width: 36,
  height: 5
})));

var SvgDeliveryDocca = function SvgDeliveryDocca(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "27 34.3 36 33.3",
    xmlSpace: "preserve",
    width: 36,
    height: 33.3,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeliveryDocca, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delivery-DOCCA.3b9a84de.svg";
export { ForwardRef as ReactComponent };